import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Persistent visitor id (for linking form leads <-> referral clicks)
export function getVisitorId() {
  let id = localStorage.getItem("kr_visitor_id");
  if (!id) {
    id =
      window.crypto && window.crypto.randomUUID
        ? window.crypto.randomUUID()
        : "v-" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("kr_visitor_id", id);
  }
  return id;
}

// Remember the visitor's contact details locally so a later Sharon click
// can be attributed to a known person.
export function rememberContact({ name, email }) {
  if (name) localStorage.setItem("kr_name", name);
  if (email) localStorage.setItem("kr_email", email);
}

export function getRememberedContact() {
  return {
    name: localStorage.getItem("kr_name") || "",
    email: localStorage.getItem("kr_email") || "",
  };
}

export async function submitLead(payload) {
  const visitorId = getVisitorId();
  if (payload.name || payload.email) rememberContact(payload);
  const { data } = await api.post("/leads", { ...payload, visitorId });
  return data;
}

export async function trackReferral({ lender, page }) {
  const visitorId = getVisitorId();
  const { name, email } = getRememberedContact();
  try {
    await api.post("/track/referral", { visitorId, lender, page, name, email });
  } catch (error) {
    // Non-blocking: never stop the user from reaching the lender.
    if (process.env.NODE_ENV === "development") {
      console.error("Referral tracking failed:", error);
    }
  }
}
